/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDRadiusDownRightIcon16Solid = forwardRef('ArrowDRadiusDownRightIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M3.25 3A4.75 4.75 0 0 0 8 7.75h3.482L9.116 5.384a1.25 1.25 0 1 1 1.768-1.768l3.651 3.652a2.45 2.45 0 0 1 0 3.464l-3.651 3.652a1.25 1.25 0 0 1-1.768-1.768l2.366-2.366H8A7.25 7.25 0 0 1 .75 3a1.25 1.25 0 1 1 2.5 0Z" })));
});
